import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from '@kodit/core/shared-ui';
import { AuthService } from '@kodit/core/services';
import { environment } from '../../../../../../../../apps/core/src/environments/environment';

@Component({
  selector: 'kodit-relevantni-dokument-preview',
  templateUrl: './relevantni-dokument-preview.component.html',
  styleUrls: ['./relevantni-dokument-preview.component.scss'],
})
export class RelevantniDokumentPreviewComponent implements OnInit {
  fileUrl: any;
  fileUrlPlain: string;
  fileType = 'application/pdf';
  isLoading = true;

  fileUrlRaw!: string;
  fileUrlEncoded!: string;

  isPdf = false;
  isImage = false;
  mimeType?: string;

  constructor(
    private _dialogConfig: DynamicDialogConfig,
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    let finalUrl: string;

    if (this._dialogConfig.data.presignedUrl) {
      finalUrl = this._dialogConfig.data.presignedUrl;
      this.detectFileTypeFromUrl(finalUrl);
    } else {
      if (this._dialogConfig.data.actionUrl.includes('?')) {
        finalUrl = `${environment.apiBaseUrl}/api/${this._dialogConfig.data.actionUrl}&access_token=${this._authService.getToken}`;
      } else {
        finalUrl = `${environment.apiBaseUrl}/api/${this._dialogConfig.data.actionUrl}?access_token=${this._authService.getToken}`;
      }
      this.isPdf = true;
    }

    this.fileUrlRaw = finalUrl;
    this.fileUrlEncoded = encodeURIComponent(finalUrl);

    setTimeout(() => {
      this.isLoading = false;
    }, 600);
  }

  private detectFileTypeFromUrl(url: string): void {
    const decoded = decodeURIComponent(url);
    const params = new URLSearchParams(decoded.split('?')[1]);

    this.mimeType = params.get('response-content-type') ?? undefined;

    this.isPdf = this.mimeType === 'application/pdf';
    this.isImage = !!this.mimeType && this.mimeType.startsWith('image/');
  }

  protected readonly encodeURIComponent = encodeURIComponent;
}
